import { ComponentBase } from 'utils/abstract-classes/component-base'
import { LeadVideoComponent } from './lead-video.component'
import { Playlist } from './playlist'

export class PlaylistStore extends ComponentBase {
    public current: string
    private playlists: Record<string, Playlist> = {}
    // LeadVideoComponent or VideoCentreComponent
    private leadVideo: LeadVideoComponent
    private initialized = false

    private static _instance: PlaylistStore
    public static getInstance(): PlaylistStore {
        return this._instance || (this._instance = new this())
    }

    /**
     * Get the current playlist
     *
     * @returns {Playlist}
     */
    public get playlist(): Playlist {
        return this.playlists[this.current]
    }

    public add(component: Playlist): void {
        if (this.isEmpty()) {
            this.current = component.playlistId
        }

        this.playlists[component.playlistId] = component
    }

    public addLeadVideo(leadVideo: LeadVideoComponent): void {
        this.leadVideo = leadVideo
    }

    public remove(id: string): void {
        delete this.playlists[id]

        if (this.isEmpty()) {
            this.initialized = false
            this.leadVideo.destroy()
        }
    }

    /**
     * Check the list is empty
     *
     * @returns {boolean}
     */
    public isEmpty(): boolean {
        return !Object.keys(this.playlists).length
    }

    public isCurrentList(playlist: Playlist): boolean {
        return this.playlist === playlist
    }

    public removeNowPlaying(): void {
        Object.keys(this.playlists).forEach((index: string) =>
            this.playlists[index].removeNowPlaying()
        )
    }

    public initLeadVideo(): void {
        if (this.initialized) {
            return
        }
        this.initialized = true
        this.leadVideo.init()
    }

    public onClick(playlistId: string, index: number): void {
        this.leadVideo.onClick(playlistId, index)
    }
}
